/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Repository factory — the single place that decides which data backend
 * the platform uses.
 *
 * Local-First API Architecture:
 *   The platform ALWAYS uses ApiModuleRepository (real HTTP calls).
 *   For local development, run: npx wrangler dev --persist-to=./.wrangler/state/v3
 *   This provides a "Mini-Cloud" locally with real D1 + R2 logic.
 */

import { IDataRepository, IModuleRepository } from '../domain/repository';
import { ApiModuleRepository } from '../data/ApiModuleRepository';

/** Combined type: supports both domain-specific and generic access patterns. */
export type FullRepository = IDataRepository & IModuleRepository;

let _instance: FullRepository | null = null;

/**
 * Returns the singleton repository instance.
 * Always uses ApiModuleRepository — local dev uses wrangler dev as the backend.
 */
export function getRepository(): FullRepository {
  if (!_instance) {
    _instance = new ApiModuleRepository() as unknown as FullRepository;
  }
  return _instance;
}

/**
 * Destroys the cached repository singleton so the next getRepository()
 * call creates a fresh instance with no stale in-memory state.
 */
export function resetRepository(): void {
  _instance = null;
}

/**
 * Always returns true — the platform only operates in API mode now.
 * Kept for backward compatibility with call sites that check mode.
 */
export function isRemoteMode(): boolean {
  return true;
}
